export default __webpack_public_path__ + "static/media/customers-inactive.b17ab0a4.svg";